import { Injectable, inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { CONNEXION } from "../constants/route.constants";
import { AuthenticationService } from "../services/authentication.service";
import { environment } from "@env/environment";
import { isPartner } from "@shared/utils/brand-utils";
import { KeycloakService } from "keycloak-angular";
import { MsalAuthenticationService } from "@shared/services/msal-authentication.service";

@Injectable({ providedIn: "root" })
export class AuthGuard {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private readonly msalAuthenticationService: MsalAuthenticationService
  ) {}

  async canActivate(): Promise<boolean> {
    console.log("AuthGuard: Checking authentication status...");

    // Pour les entrées SSO Advisor : utiliser MsalAuthenticationService
    if (this.msalAuthenticationService.isAdvisorSsoEntry()) {
      const allowed = await this.msalAuthenticationService.ensureAuthenticated(environment.apiConfig.scopes);
      if (!allowed && !this.msalAuthenticationService.isRedirectInProgress()) {
        this.router.navigate([CONNEXION]);
      }
      return allowed;
    }

    // Pour la marque HM : Keycloak
    if (isPartner(environment)) {
      console.log("AuthGuard: Using Keycloak for authentication.");
      const keycloak = inject(KeycloakService);
      const isLoggedIn = keycloak.isLoggedIn();
      console.log("AuthGuard: Keycloak logged in status:", isLoggedIn);
      if (!isLoggedIn) {
        await keycloak.login();
        return false;
      }
      console.log("AuthGuard: Keycloak user is authenticated.");
      return true;
    }

    if (this.authenticationService.isLoggedIn()) {
      return true;
    }

    this.router.navigate([CONNEXION]);
    return false;
  }
}

export const authGuard: CanActivateFn = (route, state) => {
  return inject(AuthGuard).canActivate();
};
